<template>
  <v-dialog
    v-model="dialog"
    :max-width="1200"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    persistent
  >
    <v-card v-if="!isCharacteristic && isChooseDialog" style="padding: 5px 20px">
      <v-btn icon @click="close()" >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title>Wählen Sie {{getRessourceName()}}:</v-card-title>
      <v-list-item-group
        v-model="selectedSystem"
        color="primary"
      >
      <v-list-item v-if="canEdit" @click="addConnectedRessource">
        <v-list-item-content>
          <v-list-item-title>+ {{getRessourceName()}} hinzufügen</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="ressource in connectedRessources" :key="ressource.id" @click="selectSystem(ressource)">
        <v-btn v-if="canEdit" icon color="primary" @click="editConnectedSystem(ressource, true)"><v-icon>mdi-pencil</v-icon></v-btn>
        <v-btn v-if="!canEdit" icon color="primary" @click="editConnectedSystem(ressource, false)"><v-icon>mdi-eye</v-icon></v-btn>
        <v-list-item-content>
          <v-list-item-title>{{ ressource.friendlyName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      </v-list-item-group>
    </v-card>


    <v-card v-if="!isCharacteristic && !isChooseDialog" class="dialog">
       <v-btn style="position:absolute; right:0" icon @click="isChooseDialog = true" >
        <v-icon>close</v-icon>
      </v-btn>
      <div class="header">
        <v-text-field autofocus="true"
            :disabled="!canEdit"
            :label="getRessourceName()+'titel'" v-model="newSystem.friendlyName"
          ></v-text-field>
      </div>
      <div class="description"><v-textarea
          :disabled="!canEdit"
          name="input-7-1"
          label="Beschreibung"
          v-model="newSystem.description"
          hint="Beschreibung"
          rows="10"
        ></v-textarea>
      </div>
      <div class="modelList" v-if="connectedRessourcesToProcessElements.length > 0">
        {{getRessourceName()}} ist mit folgenden Prozessen verknüpft:
        <v-expansion-panels>
          <v-expansion-panel
            v-for="ressource in connectedRessourcesToProcessElements"
            :key="ressource.id"
          >
            <v-expansion-panel-header>
              {{ressource.processId}}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              Elemente:
              <div v-for="element in ressource.elementId" :key="element">
              <hr class="elementDivider"/>
              <p style="margin-bottom:0.5px;">{{element}}</p>
              </div>
              <hr class="elementDivider"/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <RoleCharacteristicsPanel v-if="showRoleCharacteristic" :roleDescriptors="roleDescriptors" :roleId="newSystem.id" @updateDescriptor="updateDescriptor" @assessmentsChanged="assessmentsChanged"/>
      
      <br>
        <v-btn id="leftButton" text @click.stop="close()">Abbrechen</v-btn>
        <v-btn id="rightButton" v-if="canEdit" @click="saveConnectedRessource"  color="primary">Speichern</v-btn>
    </v-card>

    <v-card v-if="isCharacteristic" class="dialog">
       <v-btn style="position:absolute; right:0" icon @click="close()" >
        <v-icon>close</v-icon>
      </v-btn>
      <div class="header"><v-text-field autofocus="true"
            :label="getRessourceName()+'titel'" v-model="newSystem.friendlyName"></v-text-field>
      </div>
      <v-row>
        <v-col class="characteristicsDescription">
        <v-textarea
          v-if="ressourceType != 'ROLE'"
          name="input-7-1"
          label="Beschreibung"
          v-model="newSystem.description"
          hint="Beschreibung"
          rows="10"
        ></v-textarea>
        <v-textarea
          v-else
          name="input-7-1"
          label="Tätigkeiten"
          v-model="newSystem.description"
          hint="Tätigkeiten"
          rows="10"
        ></v-textarea>
      </v-col>
      <v-col v-if="isCharacteristic && ressourceType == 'DEPARTMENT'" class="characteristicsDescription" style="align-items:center">
        <v-label>Farbe für Abteilung</v-label><br/>
        <v-color-picker
              dot-size="25"
              hide-inputs
              hide-mode-switch
              mode="hexa"
              v-model="color"
              swatches-max-height="200"
            ></v-color-picker>
      </v-col>
      </v-row>
      <br>
      <v-btn @click="saveConnectedRessource"  color="primary">
          Speichern
      </v-btn>
    </v-card>


  </v-dialog>
</template>

<script>
import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
import RoleCharacteristicsPanel from './RoleCharacteristicsPanel.vue';
export default {
  name: "RessourcesDialog",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      options: {
        width: 400,
        zIndex: 200,
      },
      connectedRessources: [],
      selectedSystem: null,
      isChooseDialog: true,
      newSystem: {
        name: null,
        description: null,
        color: "#000000"
      },
      isCharacteristic: false,
      connectedRessourcesToProcessElements: [],
      ressourceType: "",
      canEdit: true,
      color: "#000000"
    }
  },
  watch:{
    dialog(val){
      if(val){
        this.isChooseDialog = true;
      }
    }
  },
  methods: {
    close(){
      this.newSystem = {
        name: null,
        description: null,
        color: "#000000"
      };
      this.dialog = false;
      this.reject();
    },
    getRessourceName(){
      switch(this.ressourceType){
        case "SYSTEM":
          return "System";
        case "ROLE":
          return "Rollen";
        case "CONTEXT_ITEM":
          return "Context Item";
        case "DEPARTMENT":
          return "Abteilung"
      }
    },
    initSystems(){
      this.isChooseDialog = true;
      if(this.ressourceType == null || this.ressourceType == "") return;
      connectedRessourceService.retrieveConnectedRessource(this.ressourceType).then((res) => {
        let ressources = res.data;
        ressources = ressources.filter(e => e.name != null);
        this.connectedRessources = ressources.sort((a, b) => a.name.localeCompare(b.name));
      })
    },
    editConnectedSystem(ressource){
      this.isChooseDialog = false;
      this.newSystem = ressource;
      this.color = ressource.color;
      connectedRessourceService.retrieveRessourceForModelElements(ressource.id).then((res) => {
        this.connectedRessourcesToProcessElements = res.data;
      });
    },
    openDialogInEditMode(ressource){
      this.ressourceType = ressource.type;
      this.isCharacteristic = true;
      this.canEdit = true;
      this.dialog = true;
      this.editConnectedSystem(ressource);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    addConnectedRessource(){
      this.newSystem = {
        name: null,
        description: null,
        color: "#000000"
      }
      this.isChooseDialog = false;
    },
    saveConnectedRessource(){
      this.newSystem.type = this.ressourceType;
      this.newSystem.color = this.color;
      this.newSystem.name = this.newSystem.friendlyName;
      if(this.newSystem.id != null){
        connectedRessourceService.updateConnectedRessource(this.newSystem).then(() => {
          this.newSystem = {
            name: null,
            description: null,
            color: "#000000"
          };
          if(this.isCharacteristic) {
            this.dialog = false;
            this.resolve();
          }else{
            this.initSystems();
            this.isChooseDialog = true;
          }
        })
      }else{
        connectedRessourceService.addConnectedRessource(this.newSystem).then(() => {
          this.newSystem = {
            name: null,
            description: null,
            color: "#000000"
          };
          if(this.isCharacteristic) {
            this.dialog = false;
            this.resolve();
          }else{
            this.initSystems();
            this.isChooseDialog = true;
          }
        })
      }
    
    },
    open(ressourceType, canEdit, isCharacteristic = false) {
      this.ressourceType = ressourceType;
      this.isCharacteristic = isCharacteristic;
      this.initSystems();
      this.canEdit = canEdit;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    selectSystem(ressource) {
      this.resolve(ressource);
      this.dialog = false;
    },
  },
    components: { RoleCharacteristicsPanel }
};
</script>

<style>
.dialog {
  flex-grow: 0;
  padding: 20px;
  background-color: #fff;
}

.header{
  width: 100%;
  height: 50px;
  margin: 0px;
}
.description{
  display:inline-block;
  width: calc(60% - 5px);
  height: 400px;
  margin: 15px 5px 0 0;
}
.characteristicsDescription{
  display:inline-block;
  width: 100%;
  height: 400px;
  margin: 15px 5px 0 0;
}
.modelList{
  display:inline-block;
  width: calc(40% - 15px);
  height: 400px;
  margin: 5px 0 0 15px;
  border-left: 2px solid var(--v-primary-base);
}
.elementDivider{

  margin: 1px;
  border: 0.5px solid var(--v-primary-base);
}
</style>